import { useState } from 'react';

import { useShowResponseStatus } from '@/shared';
import { useUploadPaymentMethodImageMutation, useGetPaymentMethodImagesQuery } from '../store/payment-methods-api';

import type { TPaymentMethodGetImagesParams } from '../store/types';

const initailParams: TPaymentMethodGetImagesParams = {
  pageSize: 100,
  page: 1,
};

export const useCreateMethodOptions = () => {
  const [file, setFile] = useState<File | null>(null);
  const {
    data: imageNameList,
    isLoading: isGetLoading,
    isError: isGetError,
  } = useGetPaymentMethodImagesQuery(initailParams);

  const [uploadMethodImage, {
    isLoading: isUploadLoading,
    isSuccess: isUploadSuccess,
    isError: isUploadError,
  }] = useUploadPaymentMethodImageMutation();

  useShowResponseStatus({
    isSuccess: isUploadSuccess,
    isError: isUploadError || isGetError,
    successMessage: 'Изображение успешно загружено',
    errorMassage: 'Произошла ошибка',
  });

  const handleAddImage = async (selectedFile: File | null) => {
    setFile(selectedFile);
    const formData = new FormData();

    if (selectedFile) {
      formData.append('file', selectedFile);
      await uploadMethodImage({ body: formData });
    }
  };

  return {
    imageNameList,
    file,
    isLoading: isUploadLoading || isGetLoading,
    isSuccess: isUploadSuccess,
    setFile,
    handleAddImage,
  };
};
